import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const dsgelogsConfig: TSPConfig = {
  key: 'dsgelogs',
  name: 'DSGElogs',
  category: TSPCategory.API_KEY,
  helpText: 'Please input your DSGElogs API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'API Key', name: 'apikey', type: 'text', required: true },
      ]}
    />
  ),
};

export default dsgelogsConfig;
